/* global Symbol */
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';

// lib
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import DropDownMenu from '../../../../../common/components/c_DropDownMenu';

import SubmissionBar from '../../../SubmissionBar';
import * as jobRequestApi from '../../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../../redux/actionCreators/sync/jobrequests';
import { convertToMenuItems } from '../../../../../redux/helpers/staticData';
import RouteTransitionBlocker from '../../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

// js utilities
import {get, flatten, set, map, reduce, valuesIn, isNil, cloneDeep, merge} from 'lodash';

const dropdownStyling = {
  containerStyle: {
    width: '95%',
    transform: 'translateY(-2px)'
  },
  labelStyle: {
    padding: 0
  },
  listStyle: {
    width: '100px'
  },
  menuStyle: {
    width: '100px'
  },
  iconStyle: {
    right: 0
  },
  underlineStyle: {
    display: 'none'
  }
};

// class name
// import cx from 'classnames';

@connect((store, props) => {
  const skills = get(store.jobRequest, 'skills');
  return {
    staticData: store.staticData,
    user: store.user,
    contact: store.contactProfile,
    jobRequest: store.jobRequest,
    jobId: parseInt(props.params.jobId || 0, 10),
    skills,
  };
})
class SkillsSumary extends Component {
  static propTypes = {
    params: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor(props, context) {
    super(props, context);

    // setting initial state
    this.state = {
      skills: this.props.skills,
      validation: {},
      errors: [],
      showError: false,
      showTransitionBlocker: false,
			transitionRoute: '',
      stateSaved: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.skills) {
      this.validation(nextProps.skills);
      this.setState({skills: nextProps.skills});
    }
  }

	componentDidMount() {

		this.props.router.setRouteLeaveHook(this.props.route, (location) => {

			const jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;

			if ( jobRequestSteps.test(location.pathname) ){
				this.state.primaryButtonLabel = 'Stay';
				this.state.secondaryButtonLabel = 'Leave';

			}else{
				this.state.primaryButtonLabel = undefined;
				this.state.secondaryButtonLabel = undefined;
			}

			if (!this.state.stateSaved ){
				this.setState(merge({}, this.state, {showTransitionBlocker: true,  transitionRoute: location.pathname}));
				return this.state.stateSaved;
			}else{
				return true;
			}

		});
	}

  onChange(target, prop, event, value) {
    const skills = this.state.skills;
    map(get(skills, `${target.categoryId}`), (skill, index) => {
      if (skill.name === target.name) {
        set(skills, `${target.categoryId}.${index}.${prop}`, value);
      }
    });

    this.setState({stateSaved: false});
    this.validation(skills);
  }

  validation(skills) {
    const validation = {};
    const errors = [];
    const formValid = reduce(skills, (catValid, cat) => {
      return reduce(cat, (skillValid, skill, index) => {
        const isValid = isNil(skill) || skill.name === 'None' || !isNil(skill.skillOption);
        validation[skill.name] = !isValid || null;
        return isValid && skillValid;
      }, true) && catValid;
    }, true);

    if (!formValid) {
      errors.push('Please fill out the required fields above.')
    }
    this.setState({errors, validation});
    return formValid;
  }

  save = (jobId, primaryContactId, skills) => {

    const updatedJobRequest = {
      id: jobId,
      primaryContactId: primaryContactId,
      skills: skills
    };

    const updateJobRequest =  this.props.dispatch(jobRequestApi.updateJobRequest(this.props.jobId, updatedJobRequest));

    return updateJobRequest.then( () => {

      const updatedJobRequestStore = cloneDeep(this.props.jobRequest);
      updatedJobRequestStore.skills = this.state.skills;
      return this.props.dispatch(jobRequestStore.updateJobRequest({...updatedJobRequestStore}));

    });

  }

  handleSave = (event, cb) => {

    if (!this.props.jobId)
      return false;

    this.save(this.props.jobId, this.props.contact.profile.id, this.state.skills)
      .then( () => {
         this.setState({stateSaved: true}, cb);
      });

  }

  handleSaveAndNext = (event) => {

    const hasErrors = !this.validation(this.state.skills);

    this.handleSave(event, () => {
      if (hasErrors) {
           this.setState({showError: true});
      }else{
          this.gotoNextScreen();
        }
    })

  }

  gotoNextScreen = ()  => {
       this.props.checkComplete();
       this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/workschedule`));
  }

  handleBack = (event) => {
    this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/skills/9`));
  }

	closeTransitionBlocker = () =>{
		this.setState(merge({}, this.state, {showTransitionBlocker: false}));
	}

	transitionFunction = () => {
		this.setState({stateSaved: true}, () =>  this.props.dispatch(push(this.state.transitionRoute)));
	}

  render() {
    const errorMessage = 'Please fill out all fields.';
    const errorLabel = <div className='error-message'>{errorMessage}</div>;

    const skills = flatten(valuesIn(this.props.skills));

    // Filtering out skills with none  selection.
    for (let i = skills.length -1; i >= 0; i--) {
      if(skills[i].name === 'None') {
        skills.splice(i, 1);
      }
    }
    return (
      <div className='skills-sumary'>

        {
          this.state.showTransitionBlocker
          &&
          <RouteTransitionBlocker
            cancelAction={this.closeTransitionBlocker.bind(this)}
            primaryAction={this.closeTransitionBlocker.bind(this)}
            primaryButtonLabel={this.state.primaryButtonLabel}
            secondaryAction={this.transitionFunction.bind(this)}
            secondaryButtonLabel={this.state.secondaryButtonLabel}
            transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
          />
        }

        <div>
          <div className='application-section-container clearfix'>
            <h1>Summary Skills</h1>
              <div className='summary-skills-table'>
                <Table
                  selectable={false}
                  multiSelectable={false}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn className='name'>Skill Name</TableHeaderColumn>
                      <TableHeaderColumn style={{width: '100px', paddingLeft:'2px', paddingRight:'0px'}} className='option'>Importance</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                  >
                    {
                      skills.map((row, index) =>
                        <TableRow key={`${row.categoryId}-${row.name}`}>
                          <TableRowColumn data-id={`SkillName${index}`} className='name'>
                            {row.name}
                            {!isNil(this.state.validation[row.name]) && this.state.showError && errorLabel}
                          </TableRowColumn>
                          <TableRowColumn style={{width: '100px', paddingLeft:'2px', paddingRight:'0px'}} className='option'>
                            <DropDownMenu
                              data-id={`skillOption${index}`}
                              canAutoPosition='true'
                              defaultValue={row.skillOption}
                              menuItems={convertToMenuItems(this.props.staticData.skillOptionTypes, 'id', 'name')}
                              onChange={this.onChange.bind(this, row, 'skillOption')}
                              {...dropdownStyling}
                            />
                          </TableRowColumn>
                        </TableRow>
                      )
                    }
                  </TableBody>
                </Table>
              </div>
          </div>
          <SubmissionBar
            onBack={this.handleBack}
            onNext={this.handleSaveAndNext}
            onSave={this.handleSave}
            errors={this.state.errors}
            showError={this.state.showError}
          />
        </div>
      </div>
    );
  }
}
export default withRouter(SkillsSumary);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/Skills/SkillSummary/index.js